import { requests } from '../../api/services';
import { cancelWithDocument } from '../../api/api.service';
import { LIST_CONTRACT_URL } from '../../utils/Endpoints';
import { BaseModel } from '../../model/shared/BaseModel';
import { Contract } from '../../model/contract/Contract';
import { IOfferOverview } from '../../model/offer/OfferOverview';

export interface IContractAnnexInfo {
    isAnnex: boolean;
    annexNumber: number | null;
    annexAcceptedAt: string | null;
    annexOfId: number | null;
    openAnnex: { id: number; annexNumber: number } | null;
    replacedBy: { id: number; annexNumber: number } | null;
}

export const ContractService = {
    getContracts: (params: any): Promise<BaseModel<Contract>> => requests.get(`${LIST_CONTRACT_URL}`, params),
    editContracts: (id: number, body: Contract): Promise<Contract> => requests.put(`${LIST_CONTRACT_URL}/${id}`, body),
    cancelContract: (id: number, data: { note?: string; file?: File | null }): Promise<Contract> =>
        cancelWithDocument(`${LIST_CONTRACT_URL}/${id}/cancel`, data),
    getContractAnnexInfo: (id: number): Promise<IContractAnnexInfo> =>
        requests.get(`${LIST_CONTRACT_URL}/${id}/annex-info`),
    getContractOverview: (id: number): Promise<IOfferOverview> => requests.get(`${LIST_CONTRACT_URL}/${id}/overview`),
    getContractsSchedule: (id: number, params?: any) => requests.get(`${LIST_CONTRACT_URL}/schedule/${id}`, params),
    allowUpload: (id: number, body?: any) => requests.put(`${LIST_CONTRACT_URL}/allow/${id}`, body),
    updatePurchaseOrder: (id: number, purchaseOrderInfluencer: string): Promise<Contract> =>
        requests.put(`${LIST_CONTRACT_URL}/purchase-order/${id}`, { purchaseOrderInfluencer }),
};
